import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

export const normalizePhone = (raw) => {
  let d = (raw || "").replace(/\D/g, "");
  if (d.startsWith("90") && d.length === 12) d = d.slice(2);
  if (d.startsWith("0") && d.length === 11) d = d.slice(1);
  return /^5\d{9}$/.test(d) ? `+90${d}` : null;
};

const Field = ({ label, error, children, hint }) => (
  <div>
    <label className="block font-heading font-bold text-navy mb-2">{label}</label>
    {children}
    {hint && !error && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
    {error && <p className="mt-1 text-sm text-rose-600" data-testid="field-error">{error}</p>}
  </div>
);

const inputCls = "h-12 rounded-xl text-base border-input focus-visible:ring-navy";

export function StepTwo({ form, set, errors, submitting, onBack, onSubmit }) {
  const typeBtn = (v, label) => (
    <button type="button" onClick={() => set({ student_type: v })} data-testid={`student-type-${v}`}
      className={`flex-1 rounded-xl py-3 font-bold transition-colors ${form.student_type === v ? "bg-navy text-white" : "bg-bej-light text-navy hover:bg-bej"}`}>
      {label}
    </button>
  );
  return (
    <form onSubmit={onSubmit} className="space-y-6" noValidate>
      <input type="text" name="website" tabIndex={-1} autoComplete="off" value={form.website}
        onChange={(e) => set({ website: e.target.value })} className="absolute -left-[9999px] h-0 w-0 opacity-0" aria-hidden="true" data-testid="booking-honeypot" />
      <Field label="Ad Soyad" error={errors.name} hint={form.student_type === "cocuk" ? "Velinin adı soyadı" : undefined}>
        <Input value={form.name} onChange={(e) => set({ name: e.target.value })} className={inputCls} placeholder="Adınız ve soyadınız" data-testid="booking-name-input" />
      </Field>
      <Field label="Cep telefonu" error={errors.phone} hint="WhatsApp üzerinden de size ulaşabilmemiz için cep numaranızı yazın.">
        <div className="flex">
          <span className="inline-flex items-center rounded-l-xl border border-r-0 border-input bg-bej-light px-4 font-bold text-navy">+90</span>
          <Input type="tel" inputMode="tel" value={form.phone} onChange={(e) => set({ phone: e.target.value })}
            className={`${inputCls} rounded-l-none`} placeholder="5XX XXX XX XX" data-testid="booking-phone-input" />
        </div>
      </Field>
      <Field label="Kim için?">
        <div className="flex gap-2">{typeBtn("cocuk", "Çocuğum için")}{typeBtn("yetiskin", "Kendim için (yetişkin)")}</div>
      </Field>
      <Field label="Öğrencinin yaşı" error={errors.student_age}>
        <Input type="number" min={3} max={99} value={form.student_age} onChange={(e) => set({ student_age: e.target.value })}
          className={`${inputCls} max-w-[140px]`} data-testid="booking-age-input" />
      </Field>
      <Field label="Not (isteğe bağlı)">
        <Textarea value={form.note} maxLength={500} onChange={(e) => set({ note: e.target.value })} className="rounded-xl min-h-[96px]"
          placeholder="Daha önce eğitim aldı mı, özel bir isteğiniz var mı?" data-testid="booking-note-input" />
      </Field>
      <div className="rounded-2xl bg-bej-light p-4">
        <label className="flex items-start gap-3 cursor-pointer">
          <Checkbox checked={form.kvkk_consent} onCheckedChange={(v) => set({ kvkk_consent: !!v })} className="mt-1" data-testid="booking-kvkk-checkbox" />
          <span className="text-sm text-slate-700 leading-relaxed">
            <Link to="/kvkk" target="_blank" className="font-bold text-navy underline" data-testid="booking-kvkk-link">KVKK Aydınlatma Metni</Link>'ni okudum.
            {form.student_type === "cocuk" ? " Velisi olarak çocuğuma ait" : " Bana ait"} kişisel verilerin randevu talebinin değerlendirilmesi ve benimle iletişim kurulması amacıyla işlenmesine açık rıza veriyorum.
          </span>
        </label>
        {errors.kvkk_consent && <p className="mt-2 text-sm text-rose-600" data-testid="kvkk-error">{errors.kvkk_consent}</p>}
      </div>
      {errors.form && <p className="rounded-xl bg-rose-50 border border-rose-200 p-3 text-sm text-rose-700" data-testid="booking-form-error">{errors.form}</p>}
      <div className="flex flex-col-reverse sm:flex-row gap-3">
        <button type="button" onClick={onBack} data-testid="booking-back-btn" className="rounded-full bg-bej px-8 py-3.5 font-heading font-bold text-navy hover:bg-bej-dark transition-colors">Geri</button>
        <button type="submit" disabled={submitting} data-testid="booking-submit-btn"
          className="rounded-full bg-navy px-8 py-3.5 font-heading font-bold text-white hover:bg-navy-dark transition-colors disabled:opacity-50">
          {submitting ? "Gönderiliyor…" : "Talebi gönder"}
        </button>
      </div>
    </form>
  );
}
